import React from 'react'

import classes from './layout.css'
import TextArea from '../Fields/TextArea'

const ModuleEleven = (props) => {
	return (
		<div className={classes.Container}>
			<p>You have the right to be informed about your diagnosis, options and planned surgery so that you can decide whether or not to have a procedure after knowing the risks and benefits.</p>
			<div className={classes.ListItem}>
				Your diagnosis is:
				<TextArea 
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"diagnosis"}
					value={props.consentForm.diagnosis}
				/>
			</div>

			<div className={classes.ListItem}>
				Your planned treatment is:
				<TextArea 
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"plannedTreatment"}
					value={props.consentForm.plannedTreatment}
				/>
			</div>

			<div className={classes.ListItem}>
				Alternative treatment methods include:
				<TextArea 
					controlFunc={props.addToForm}
					inputType={"text"}
					name={"altTreatment"}
					value={props.consentForm.altTreatment}
				/>
			</div>
		</div>
	)
}

export default ModuleEleven


// WEBPACK FOOTER //
// ./src/components/Modules/11.js